/**
 * 液态玻璃（liquid glass）样式预设
 *
 * 三档预设匹配当前设计意图：
 *   card  — 中等透明 + 阴影，用于信息卡片（profile 等）
 *   panel — 强模糊 + 低阴影，用于覆盖层面板（login / modal 等）
 *   hero  — 弱背景 + 内高光，用于 Hero 区大面积叠加
 *
 * 使用方式：<div style={glass.card} /> 或 <div style={{ ...glass.card, background: '...' }} />
 */

export const glass = {
  card: {
    background: 'rgba(255,255,255,0.58)',
    backdropFilter: 'blur(22px) saturate(190%)',
    WebkitBackdropFilter: 'blur(22px) saturate(190%)',
    border: '0.5px solid rgba(255,255,255,0.82)',
    boxShadow: '0 4px 24px rgba(0,0,0,0.05)',
  },
  panel: {
    background: 'rgba(255,255,255,0.60)',
    backdropFilter: 'blur(32px) saturate(200%)',
    WebkitBackdropFilter: 'blur(32px) saturate(200%)',
    border: '0.5px solid rgba(255,255,255,0.85)',
  },
  hero: {
    background: 'rgba(255,255,255,0.18)',
    backdropFilter: 'blur(32px) saturate(210%)',
    WebkitBackdropFilter: 'blur(32px) saturate(210%)',
    border: '0.5px solid rgba(255,255,255,0.65)',
    boxShadow: 'inset 0 1.5px 0 rgba(255,255,255,0.85), 0 4px 24px rgba(0,0,0,0.04)',
  },
} as const;
